export const FOODBASEDANALYSIS_GETNUTRITIONSTANDARDS_LOADING =
  'FOODBASEDANALYSIS_GETNUTRITIONSTANDARDS_LOADING';
export const FOODBASEDANALYSIS_GETNUTRITIONSTANDARDS_SUCCESS =
  'FOODBASEDANALYSIS_GETNUTRITIONSTANDARDS_SUCCESS';
export const FOODBASEDANALYSIS_GETNUTRITIONSTANDARDS_ERROR =
  'FOODBASEDANALYSIS_GETNUTRITIONSTANDARDS_ERROR';

export const FOODBASEDANALYSIS_GETCYCLEMENUS_LOADING =
  'FOODBASEDANALYSIS_GETCYCLEMENUS_LOADING';
export const FOODBASEDANALYSIS_GETCYCLEMENUS_SUCCESS =
  'FOODBASEDANALYSIS_GETCYCLEMENUS_SUCCESS';
export const FOODBASEDANALYSIS_GETCYCLEMENUS_ERROR =
  'FOODBASEDANALYSIS_GETCYCLEMENUS_ERROR';



// WEBPACK FOOTER //
// ./src/pages/reports/menus/foodbasedanalysisreport/state/types.js